import { Badge, Button, Nav } from '@valid-eval/shared-react-components';
import cx from 'classnames';
type DashboardTabButtonProps = {
  active: boolean;
  label: string;
  badge: string;
  eventKey: string;
};

const DashboardTabButton = ({ active, label, badge, eventKey }: DashboardTabButtonProps) => {
  return (
    <Nav.Link
      className="d-flex align-items-center"
      eventKey={eventKey}
      as={Button}
      variant={active ? 'primary' : 'default'}
    >
      {label}
      <Badge
        style={{ top: 0 }}
        className={cx('ms-2', {
          'text-blue04': active,
          'text-white': !active,
        })}
        bg={active ? 'light' : 'blue03'}
      >
        {badge}
      </Badge>
    </Nav.Link>
  );
};

export default DashboardTabButton;
